import { FilterField } from '../services/filter.service';

export const PROJECT_DATA_FILTER_FIELDS: FilterField[] = [
  { key: 'search', label: 'Search Name and Description', type: 'text' },
  { key: 'prgName', label: 'Project Name', type: 'multi-select' },
  { key: 'prgType', label: 'Project Type', type: 'multi-select' },
  { key: 'itbApproved', label: 'Investment Approval Status', type: 'multi-select' },
  { key: 'invCat', label: 'Investment Category', type: 'multi-select' },
  { key: 'invPr', label: 'Investment Priority', type: 'multi-select' },
  { key: 'stage', label: 'Project Stage', type: 'multi-select' },
  { key: 'rag', label: 'RAG Status', type: 'multi-select' },
  { key: 'sponsor', label: 'Project Sponsor', type: 'multi-select' },
  { key: 'manager', label: 'Project Manager', type: 'multi-select' },
  { key: 'benefits', label: 'Project Benefits', type: 'multi-select' },
  { key: 'orphans', label: 'Orphans', type: 'multi-select', isOrphans: true }
];

export const APPLICATION_DATA_FILTER_FIELDS: FilterField[] = [
  { key: 'search', label: 'Search Name and Description', type: 'text' },
  { key: 'appName', label: 'Application Name', type: 'multi-select' },
  { key: 'location', label: 'Hosting Location', type: 'multi-select' },
  { key: 'criticality', label: 'Business Criticality', type: 'multi-select' },
  { key: 'coverage', label: 'Geographic Coverage', type: 'multi-select' },
  { key: 'category', label: 'Application Category', type: 'multi-select' },
  { key: 'owner', label: 'Application Owner', type: 'multi-select' },
  { key: 'provider', label: 'Application Maker', type: 'multi-select' },
  { key: 'type', label: 'Application Type', type: 'multi-select' },
  { key: 'status', label: 'Application Status', type: 'multi-select' },
  { key: 'orphans', label: 'Orphans', type: 'multi-select', isOrphans: true }
];

export const SUPPLIER_DATA_FILTER_FIELDS: FilterField[] = [
  { key: 'search', label: 'Search Name and Description', type: 'text' },
  { key: 'supplierName', label: 'Supplier Name', type: 'multi-select' },
  { key: 'supplierTier', label: 'Supplier Tier', type: 'multi-select' },
  { key: 'conOwner', label: 'Relationship Owner', type: 'multi-select' },
  { key: 'conStatus', label: 'Supplier Status', type: 'multi-select' },
  { key: 'region', label: 'Region', type: 'multi-select' },
  { key: 'country', label: 'Country', type: 'multi-select' },
  { key: 'orphans', label: 'Orphans', type: 'multi-select', isOrphans: true }
];

export const HR_DATA_FILTER_FIELDS: FilterField[] = [
  { key: 'search', label: 'Search Name and Description', type: 'text' },
  { key: 'empName', label: 'Full Name', type: 'multi-select' },
  { key: 'division', label: 'IT Division', type: 'multi-select' },
  { key: 'type', label: 'Employee Type', type: 'multi-select' },
  { key: 'supplier', label: 'Employer Name', type: 'multi-select' },
  { key: 'orphans', label: 'Orphans', type: 'multi-select', isOrphans: true, disabled: true }
];

export const OT_DATA_FILTER_FIELDS: FilterField[] = [
  { key: 'search', label: 'Search Name and Description', type: 'text' },
  { key: 'assetName', label: 'Asset Name', type: 'multi-select' },
  { key: 'assetType', label: 'Asset Type', type: 'multi-select' },
  { key: 'manufacturer', label: 'Manufacturer', type: 'multi-select' },
  { key: 'criticality', label: 'Operational Criticality', type: 'multi-select' },
  { key: 'location', label: 'Asset Location', type: 'multi-select' },
  { key: 'businessOwner', label: 'Business Owner', type: 'multi-select' },
  { key: 'supportOwner', label: 'Support Owner', type: 'multi-select' },
  { key: 'inSupport', label: 'In Support?', type: 'multi-select' },
  { key: 'connected', label: 'Connected?', type: 'multi-select' },
  { key: 'model', label: 'Model', type: 'multi-select' },
  { key: 'assetUtilisation', label: 'Utilisation', type: 'multi-select' },
  { key: 'redundancy', label: 'Redundancy', type: 'multi-select' },
  { key: 'orphans', label: 'Orphans', type: 'multi-select', isOrphans: true },
];

// Orphans filter options (same for all data types)
export const ORPHANS_FILTER_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' }
];
